import { render, staticRenderFns } from "./BMWMCustomerTreatmentColumn.vue?vue&type=template&id=62e76b86&scoped=true&"
import script from "./BMWMCustomerTreatmentColumn.vue?vue&type=script&lang=js&"
export * from "./BMWMCustomerTreatmentColumn.vue?vue&type=script&lang=js&"
import style0 from "./BMWMCustomerTreatmentColumn.vue?vue&type=style&index=0&id=62e76b86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e76b86",
  null
  
)

export default component.exports